<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Editare Configurație Programare</h1>
    </div>

    <div class="mt-3 mb-3 p-2" style="background-color: #e3f2fd; border-radius: 8px;">
        <small class="text-muted">
            <i class="fa-solid fa-info-circle me-1"></i>
            Modificarea tipului de problemă sau tipului de program nu va afecta data și ora programării.
        </small>
    </div>

    <form [formGroup]="form">
        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Problemă</mat-label>
                    <mat-select formControlName="id_problem_type">
                        <mat-option [value]="-1">-- Selectați --</mat-option>
                        <mat-option *ngFor="let tip of tipuriProblema" [value]="tip.id">
                            {{ tip.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="loadingNomenclatoare">Se încarcă...</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip Program</mat-label>
                    <mat-select formControlName="id_program_type">
                        <mat-option [value]="-1">-- Selectați --</mat-option>
                        <mat-option *ngFor="let tip of tipuriProgram" [value]="tip.id">
                            {{ tip.name }}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="loadingNomenclatoare">Se încarcă...</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="loadingNomenclatoare"
                    (click)="submitForm()">
                    Actualizează
                </button>
            </div>
        </div>
    </form>

    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>